import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../service/auth/auth.service';
import { environment } from '../../../environments/environment';
import { checkRoleAccess } from './role-guard.helper';
import { NotificationService } from '../../service/core/notification.service';

@Injectable({
  providedIn: 'root'
})
export class BussolaAuthGuard {

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly notificationService: NotificationService,
  ) {}

  canActivate(_route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (environment.UNSECURE) {
      return true;
    }

    return checkRoleAccess(this.authService, this.router, this.notificationService, () => this.authService.hasManagerBussolaAccess());
  }
}
